"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
const OrgTemplateModel_1 = __importDefault(require("./OrgTemplateModel"));
class AlertModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.recipientStaff = [];
        this.recipientPositions = [];
        this.recipientTeams = [];
        this.title = '';
        this.read = false;
        super.init(o);
    }
    get __typename() {
        return 'Alert';
    }
    set __typename(v) {
    }
}
exports.AlertModel = AlertModel;
AlertModel.ALL_FIELDS = `id,
        title,
        read,
        sentDate,
        place { id, title },
        actionPerformerStaff { id, positions { team { id, title }}, title, profileImageUrl },
        performedOnSPTType,
        performedOnStaff { id, title },
        performedOnTeam { id, title },
        performedOnPosition { id, title },
        actionType,
        relatedIssue { id, title, place { id, title, timezone }, flag, comments, activity, status, type, occurrenceDate, deadlineDate, closedDate, updatedDate },
		relatedOp { id, title, place { id, title, timezone }, startFrom, completeBy, actualStart, actualComplete, missedDeadlineDate, closedDate, teams { id, title }, allPTsPermitted }
    `;
exports.default = AlertModel;
ModelRegistry_1.default[DataType_1.default.ALERT] = AlertModel;
ModelRegistry_1.default[DataType_1.default.ORGTEMPLATE] = OrgTemplateModel_1.default;
